import { useMutation } from '@hooks/reactQuery';

import { checkOperationWindowRuleName } from '@api/operationWindowRules';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IName } from '@interfaces/common/common';
import { IResponseError } from '@interfaces/errors/apiErrors';

import { EUserRoles } from '@enums/common';
import { EErrorCodes } from '@enums/errorCodes';

import { OPERATION_WINDOW_RULES_CHECK_NAME } from '@constants/queryKeys';

interface IUseMutateOperationWindowRulesCheckNameReturned {
	isLoadingCheckRuleName: boolean;
	checkRuleName: (dto: IName) => Promise<boolean>;
	checkRuleNameError?: string;
	resetCheckRuleName: () => void;
}

const useMutateOperationWindowRulesCheckName = (): IUseMutateOperationWindowRulesCheckNameReturned => {
	const {
		isLoading,
		mutateAsync,
		error,
		reset,
	} = useMutation<IName, boolean, IResponseError>({
		mutationKey: [OPERATION_WINDOW_RULES_CHECK_NAME],
		mutationFn: checkOperationWindowRuleName,
		onError: (err: IResponseError) => {
			if (!err.errors.find((item) => (
				item.code === EErrorCodes.uniqueName ||
				item.code === EErrorCodes.nameMustBeUnique ||
				item.code === EErrorCodes.nameSize ||
				item.code === EErrorCodes.namePattern
			))) {
				handleErrorFromMessage(err);
			}
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		checkRuleName: mutateAsync,
		resetCheckRuleName: reset,
		checkRuleNameError: error?.errors.map((item) => item.message).join(' ') || undefined,
		isLoadingCheckRuleName: isLoading,
	};
};

export default useMutateOperationWindowRulesCheckName;
